import { useState } from 'react'
import { Link } from 'react-router'

import { Button } from '../components/ui/button'
import { Input } from '../components/ui/input'
import { api } from '../lib/api'

export function ForgotPassword() {
    const [email, setEmail] = useState('')
    const [hecho, setHecho] = useState(false)
    const [enviando, setEnviando] = useState(false)

    async function enviar(e: React.FormEvent) {
        e.preventDefault()
        setEnviando(true)
        try {
            await api.post('/auth/forgot', { email })
        } finally {
            setHecho(true)
            setEnviando(false)
        }
    }

    return (
        <div className="grid min-h-screen place-items-center bg-neutral-950 font-mono text-neutral-200">
            <form onSubmit={(e) => void enviar(e)} className="mx-4 w-full max-w-80 space-y-4 rounded-lg border border-neutral-800 p-6">
                <div>
                    <h1 className="text-sm font-semibold text-neutral-100">Restablecer contraseña</h1>
                    <p className="mt-1 text-xs text-neutral-500">
                        Si el correo existe, enviaremos un enlace.
                    </p>
                </div>
                <Input
                    aria-label="Correo"
                    type="email"
                    autoComplete="username"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                {hecho && (
                    <p role="status" className="text-xs text-neutral-400">
                        Si hay una cuenta con ese correo, recibirás un enlace en breve.
                    </p>
                )}
                <Button type="submit" className="min-h-11 w-full" disabled={enviando || !email || hecho}>
                    {enviando ? 'Enviando…' : 'Enviar enlace'}
                </Button>
                <Link to="/login" className="block text-center text-xs text-neutral-500 hover:text-neutral-300">
                    Volver al login
                </Link>
            </form>
        </div>
    )
}
